import { render, staticRenderFns } from "./Incasat.vue?vue&type=template&id=4aa2af06"
import script from "./Incasat.vue?vue&type=script&lang=js"
export * from "./Incasat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports